import { RootState } from "../../store";

export default function getRegulationType({ user, configuration }: RootState) {
  return user.regulationType || configuration.brandRegulationTypeID;
}
